module.exports = __webpack_public_path__ + "img/riskMonitor.0d40a71a.jpg";